import {ExpenseType, InvoiceStatus} from "@/models/Enums";
import Expense from "@/models/server/Expense";

export default class InvoiceExpense {
    public id: string | null = null;
    public invoiceId: string | null = null;
    public expenseId: string | null = null;
    public expenseType: ExpenseType | null = null;
    public name: string | null = null;
    public amount: number | null = null;
    public status: InvoiceStatus = InvoiceStatus.Pending;
    public externalId: string | null = null;
    public shouldInvoice: boolean = false;
    public modified: boolean = false;

    public static readyForInvoicing(invoiceExpense: InvoiceExpense, expenses: Expense[]): boolean {
        let ok = invoiceExpense.amount != null && invoiceExpense.amount > 0 && !!invoiceExpense.expenseId;

        if (invoiceExpense.modified) {
            ok &&= invoiceExpense.shouldInvoice;
        }

        const matchingExpense = expenses.firstOrDefault(exp => exp.id == invoiceExpense.expenseId);

        const invoiceable = matchingExpense?.isInvoiceable ?? false;

        return ok && invoiceable;
    }
}